export const isSaasDistribution = () => {
  return process.env.REACT_APP_SELF_HOSTED !== "true";
};

export const isSelfHostedDistribution = () => {
  return process.env.REACT_APP_SELF_HOSTED === "true";
};

export const withoutPublicWorkerPool = () => {
  return isSelfHostedDistribution() || process.env.REACT_APP_DISABLE_PUBLIC_WORKER_POOL === "true";
};
